// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isotop-item {
  height: fit-content !important;
}

@media (max-width: 991px) {
  .main_menu_2 {
    display: none !important;
  }
}

.projectsGrid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;
  grid-gap: 0;
  align-content: start;
}

.projectsGrid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;
  grid-auto-rows: minmax(100px, auto);
  grid-gap: 0;
  align-content: start;
}
.projectsGrid .isotop-item {
  overflow: hidden !important;
}

.bostami-parsonal-info-social-link {
  width: 230px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0px 7.5px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.handleHover:hover {
  color: var(--common-black) !important;
}

.sunicon {
  font-size: 20px;
  color: #fff;
}

.moonicon {
  font-size: 20px;
}

.mode-btn {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.mode-btn:hover {
  color: #fff;
}

.fadeup {
  animation: fadeup 0.5s linear 0s 1 backwards;
}

.fadeingpre > * {
  animation: fafein 1.5s linear 0s 1 backwards;
}

@keyframes fafein {
  0% {
    opacity: 0;
  }
  55% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeup {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    transform: translateY(0px);
  }
}
body .form-input-item input {
  color: var(--common-black);
}
body .form-input-item textarea {
  color: var(--common-black);
}
body.dark-theme .form-input-item input {
  color: #fff;
}
body.dark-theme .form-input-item textarea {
  color: #fff;
}

body {
  background-position: center center;
  background-size: cover;
}

.modal-header {
  width: fit-content !important;
  z-index: 1100 !important;
}

.cursor-pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/custom.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;;AAEE;EADF;IAEI,wBAAA;EAEF;AACF;;AACA;EACE,wBAAA;EACA,sEAAA;EAEA,WAAA;EACA,oBAAA;AACF;;AACA;EACE,wBAAA;EACA,sEAAA;EACA,mCAAA;EACA,WAAA;EACA,oBAAA;AAEF;AADE;EAEE,2BAAA;AAEJ;;AACA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAEF;;AACE;EACE,qCAAA;AAEJ;;AACA;EACE,eAAA;EACA,WAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AADA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AAIF;AAHE;EACE,WAAA;AAKJ;;AADA;EACE,4CAAA;AAIF;;AAAE;EACE,4CAAA;AAGJ;;AACA;EACE;IACE,UAAA;EAEF;EAAA;IACE,UAAA;EAEF;EAAA;IACE,UAAA;EAEF;AACF;AAAA;EACE;IACE,UAAA;IACA,2BAAA;EAEF;EACA;IACE,0BAAA;EACF;AACF;AAII;EACE,0BAAA;AAFN;AAII;EACE,0BAAA;AAFN;AAOM;EACE,WAAA;AALR;AAOM;EACE,WAAA;AALR;;AAgBA;EACE,kCAAA;EACA,sBAAA;AAbF;;AAeA;EACE,6BAAA;EACA,wBAAA;AAZF;;AAcA;EACE,eAAA;AAXF","sourcesContent":[".isotop-item {\n  height: fit-content !important;\n}\n.main_menu_2 {\n  @media (max-width: 991px) {\n    display: none !important;\n  }\n}\n\n.projectsGrid {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;\n  // grid-auto-rows: none !important;\n  grid-gap: 0;\n  align-content: start;\n}\n.projectsGrid {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;\n  grid-auto-rows: minmax(100px, auto);\n  grid-gap: 0;\n  align-content: start;\n  .isotop-item {\n    // max-height: fit-content;\n    overflow: hidden !important ;\n  }\n}\n.bostami-parsonal-info-social-link {\n  width: 230px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0px 7.5px;\n  margin: 0 auto;\n  margin-bottom: 30px;\n}\n.handleHover {\n  &:hover {\n    color: var(--common-black) !important ;\n  }\n}\n.sunicon {\n  font-size: 20px;\n  color: #fff;\n}\n.moonicon {\n  font-size: 20px;\n}\n.mode-btn {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  &:hover {\n    color: #fff;\n  }\n}\n\n.fadeup {\n  animation: fadeup 0.5s linear 0s 1 backwards;\n}\n\n.fadeingpre {\n  & > * {\n    animation: fafein 1.5s linear 0s 1 backwards;\n  }\n}\n\n@keyframes fafein {\n  0% {\n    opacity: 0;\n  }\n  55% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeup {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0px);\n  }\n}\n\nbody {\n  .form-input-item {\n    input {\n      color: var(--common-black);\n    }\n    textarea {\n      color: var(--common-black);\n    }\n  }\n  &.dark-theme {\n    .form-input-item {\n      input {\n        color: #fff;\n      }\n      textarea {\n        color: #fff;\n      }\n    }\n  }\n}\n// .btn-1{\n//     &:focus{\n//         color: #fff !important;\n//     }\n// }\n\nbody {\n  background-position: center center;\n  background-size: cover;\n}\n.modal-header {\n  width: fit-content !important;\n  z-index: 1100 !important;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
